/** 企業中心 M 端入駐流程（join/components/m） */
export default {
	common: {
		cancel: "取消",
		confirm: "確定",
		translate: "翻譯",
	},
	stepBasic: {
		sectionBasic: "基礎信息",
		sectionMedia: "機構圖片/視頻",
		sectionDetail: "機構詳情",
		sectionManager: "管理人介紹",
		sectionService: "服務設置",
		orgName: "機構名稱",
		orgNamePh: "請輸入機構名稱",
		orgNameReq: "請輸入機構名稱",
		orgNameEn: "機構英文名稱",
		orgNameEnPh: "請填寫英文機構名稱",
		orgNameEnReq: "請填寫英文機構名稱",
		category: "機構分類",
		categoryPh: "請選擇機構分類",
		categoryReq: "請選擇機構分類",
		businessStatus: "營業狀態",
		businessStatusPh: "請選擇營業狀態",
		businessStatusReq: "請選擇營業狀態",
		businessHours: "營業時間",
		businessHoursReq: "請設置營業時間",
		contactPhone: "聯繫電話",
		contactPhoneReq: "請設置聯繫電話",
		orgAddress: "機構地址",
		orgAddressPh: "請選擇機構地址",
		orgAddressReq: "請選擇機構地址",
		addressInfo: "地址信息",
		addressInfoPh: "請選擇省/市/區",
		addressInfoReq: "請選擇省/市/區",
		detailAddress: "詳細地址",
		detailAddressPh: "請填寫詳細地址, 精確到門牌號",
		detailAddressReq: "請填寫詳細地址",
		addressEn: "英文詳細地址",
		addressEnPh: "請填寫英文詳細地址",
		addressEnReq: "請填寫英文詳細地址",
		coordinates: "經緯度",
		coordinatesPh: "點擊按鈕獲取經緯度",
		coordinatesReq: "請獲取經緯度",
		getCoords: "獲取",
		cover: "機構頭像",
		coverReq: "請上傳機構頭像",
		uploadCover: "上傳機構頭像",
		shopImages: "商家圖片",
		shopImagesReq: "請上傳商家圖片",
		uploadShopImages: "上傳商家圖片",
		video: "視頻",
		videoReq: "請上傳商家視頻",
		uploadVideo: "上傳商家視頻",
		labelTraditional: "繁體",
		descTraditionalReq: "請輸入繁體簡介",
		descTraditionalPh: "請輸入繁體簡介",
		labelEnglish: "英文",
		descEnglishReq: "請輸入英文簡介",
		descEnglishPh: "請輸入英文簡介",
		editorLoading: "載入中...",
		managerAvatar: "頭像",
		managerAvatarReq: "請上傳管理人頭像",
		uploadManagerAvatar: "上傳頭像",
		managerDescZh: "繁體",
		managerDescZhPh: "請輸入繁體管理人介紹",
		managerDescZhReq: "請輸入繁體管理人介紹",
		managerDescEn: "英文",
		managerDescEnPh: "請輸入英文管理人介紹",
		managerDescEnReq: "請輸入英文管理人介紹",
		services: "服務",
		servicesReq: "請設置服務",
		restore: "恢復",
		save: "保存",
		next: "下一步",
		toastAddressFirst: "請先填寫完整以上地址信息",
		toastRestored: "已恢復",
		toastSaved: "已保存",
	},
	stepQualification: {
		title: "機構資質",
		orgName: "機構名稱",
		orgNameEn: "英文名稱",
		orgAddress: "機構地址",
		certificate: "社團登記證",
		certificateReq: "請上傳社團登記證",
		uploadImage: "上傳圖片",
		certificateTip: "使用社團登記證原件拍照,證件文字清晰",
		managerName: "管理者姓名",
		managerNamePh: "請輸入管理者姓名",
		managerNameReq: "請輸入管理者姓名",
		managerArea: "管理人地區",
		managerAreaPh: "+852 香港",
		managerAreaReq: "請選擇地區",
		managerPhone: "管理人手機",
		managerPhonePh: "請輸入手機號",
		managerPhoneReq: "請輸入手機號",
	},
	contactPhone: {
		addTitle: "添加聯繫電話",
		typeMobile: "手機號",
		typeLandline: "座機號",
		header: "添加聯繫電話",
		chooseType: "請選擇號碼類型",
		enterMobile: "請輸入手機號",
		enterLandline: "請輸入座機號",
		areaCodePh: "請填寫區號",
		landlinePh: "請填寫座機號碼",
		extPh: "分機號 (選填)",
		mobilePh: "請填寫手機號",
		regionPh: "+852 香港",
		toastMobile: "請輸入手機號",
		toastArea: "請填寫區號",
		toastLandline: "請填寫座機號碼",
	},
	businessHour: {
		add: "添加營業時間",
		modalTitle: "添加服務時間",
		selectDay: "請選擇營業日",
		tipUsed: "已配置過的營業日不可重複選擇",
		selectTime: "請選擇營業時段",
		startPh: "請選擇開始時間",
		endPh: "請選擇結束時間",
		to: "至",
		toastDay: "請選擇營業日",
		toastTime: "請選擇營業時段",
		toastTimeOrder: "開始時間不能大於或等於結束時間",
		hourSuffix: "時",
		minuteSuffix: "分",
		dayMon: "週一",
		dayTue: "週二",
		dayWed: "週三",
		dayThu: "週四",
		dayFri: "週五",
		daySat: "週六",
		daySun: "週日",
	},
	videoUpload: {
		defaultUpload: "上傳視頻",
		defaultTip: "支持 MP4、AVI、MOV 等格式，最大 50MB",
		uploading: "視頻上傳中...",
		processing: "視頻處理中...",
		preparing: "準備上傳...",
		uploadProgressPercent: "上傳中 {p}%",
		uploadProgressLabel: "上傳進度",
		altCover: "視頻封面",
		maxVideos: "最多只能上傳 {n} 個視頻",
		needVideo: "請上傳視頻文件",
		maxSize: "視頻大小不能超過50MB",
		processFail: "文件處理失敗",
		uploadOk: "視頻上傳成功",
		uploadFail: "上傳失敗",
		removed: "視頻已移除",
	},
	uploadMedia: {
		altImage: "圖片",
		cropTitle: "圖片裁切",
		cropUnavailable: "裁切功能暫時不可用",
		directUpload: "直接上傳",
		loadingImage: "圖片加載中...",
		cropTips: "提示：雙指縮放，單指拖動",
		confirmUpload: "確定並上傳",
		defaultText: "上傳",
		maxFiles: "最多只能上傳 {n} 個文件",
		pickImageOrVideo: "請選擇圖片或視頻文件",
		pickImage: "請選擇圖片文件",
		pickVideo: "請選擇視頻文件",
		imageTooBig: "圖片文件過大，請選擇小於 20MB 的圖片",
		readFail: "圖片讀取失敗",
		formatUnsupported: "圖片格式不支持",
		readFailMsg: "圖片讀取失敗：{msg}",
		readCancelled: "圖片讀取已取消",
		cannotRead: "無法讀取圖片文件",
		noUrl: "上傳失敗：未返回文件URL",
		uploadOk: "上傳成功",
		loadFailDirect: "圖片加載失敗，請嘗試直接上傳",
		fileMissing: "文件不存在",
		processFail: "圖片處理失敗",
		cropFail: "裁切失敗",
		imageNotLoaded: "圖片未加載",
		cropUnavailableToast: "裁切功能暫時不可用，請使用直接上傳",
		loadFail: "圖片加載失敗",
		cropOpFail: "裁切操作失敗",
		unknownError: "未知錯誤",
		uploadFail: "上傳失敗",
		cropperNotInit: "裁切器未初始化",
	},
	serviceModal: {
		add: "添加服務",
		edit: "編輯服務",
		addTitle: "添加服務",
		image: "圖片",
		imageReq: "請上傳服務圖片",
		uploadImage: "上傳圖片",
		name: "名稱",
		namePh: "請輸入服務名稱",
		nameReq: "請輸入服務名稱",
		nameEn: "名稱(英文)",
		nameEnPh: "請輸入英文服務名稱",
		nameEnReq: "請輸入英文服務名稱",
		intro: "簡介",
		introPh: "請輸入服務簡介",
		introReq: "請輸入服務簡介",
		introEn: "簡介(英文)",
		introEnPh: "請輸入英文服務簡介",
		introEnReq: "請輸入英文服務簡介",
		detailZh: "詳情(繁體)",
		detailZhPh: "請輸入服務詳情",
		detailZhReq: "請輸入服務詳情（繁體）",
		detailEn: "詳情(英文)",
		detailEnPh: "請輸入服務詳情",
		detailEnReq: "請輸入服務詳情（英文）",
		price: "服務價格（美元）",
		pricePh: "請填寫服務美元價格，且價格須≥1",
		priceReq: "請輸入服務價格（美元）",
		priceInvalid: "請輸入有效的價格",
		priceUsdInvalid: "請輸入有效的服務價格（美元）",
		deleting: "正在刪除服務...",
		deleted: "服務已刪除",
		deleteFail: "刪除失敗，請重試",
		removed: "服務已移除",
		saving: "正在保存服務...",
		updated: "服務更新成功",
		created: "服務創建成功",
		opFail: "操作失敗，請重試",
	},
	header: {
		logoText: "先知命局合作中心",
		logout: "登出",
		nicknameFallback: "用戶暱稱",
		langHintZh: "切換到英文",
		langHintEn: "切換到繁體中文",
	},
	stepWaiting: {
		title: "提交成功",
		body: "您的機構信息已提交審核，審核期間相關信息暫不支持修改。工作人員將在3-10個工作日內反饋審核結果，結果將發送至您的登錄手機、郵箱，請留意查收。",
		return: "返回",
	},
};
